module.exports = "<div class=\"<%= gwPaQuickQuoteMap %>\" id=\"{{$ctrl.mapName || 'googleMapsComponent'}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/quickquote/pa/directives/LocationMap/map.html
// module id = 1084
// module chunks = 0